/* eslint-disable sonarjs/no-duplicate-string */
const previewOpenEnded = require('@/assets/images/slide-type-preview/open-ended.svg')
const previewWordCloud = require('@/assets/images/slide-type-preview/word-cloud.svg')
const previewScale = require('@/assets/images/slide-type-preview/scales.svg')
const previewQuestion = require('@/assets/images/slide-type-preview/q&a.svg')
const previewPickAnswer = require('@/assets/images/slide-type-preview/pick-answer.svg')
const previewPickImage = require('@/assets/images/slide-type-preview/pick-image.svg')
const previewTypeAnswer = require('@/assets/images/slide-type-preview/type-answer.svg')
const previewHeading = require('@/assets/images/slide-type-preview/heading.svg')
const previewBulletPoints = require('@/assets/images/slide-type-preview/list.svg')
const previewQrcode = require('@/assets/images/slide-type-preview/qr-code.svg')
const previewImage = require('@/assets/images/slide-type-preview/image.svg')
const previewYoutube = require('@/assets/images/slide-type-preview/youtube.svg')
const previewDocument = require('@/assets/images/slide-type-preview/document.svg')
const previewGoogleSlide = require('@/assets/images/slide-type-preview/google-slides.svg')
const previewSpinnerWheel = require('@/assets/images/slide-type-preview/spinner-wheel.svg')
const previewBrainstorm = require('@/assets/images/slide-type-preview/brainstorm.svg')
const previewMatchPairs = require('@/assets/images/slide-type-preview/match-pairs.svg')
const previewCorrectOrder = require('@/assets/images/slide-type-preview/correct-order.svg')
const previewPoll = require('@/assets/images/slide-type-preview/poll.svg')
const previewContent = require('@/assets/images/slide-type-preview/content.svg')

// French image
const previewOpenEndedFr = require('@/assets/images/slide-type-preview/fr/open-ended.svg')
const previewWordCloudFr = require('@/assets/images/slide-type-preview/fr/word-cloud.svg')
const previewScaleFr = require('@/assets/images/slide-type-preview/fr/scales.svg')
const previewQuestionFr = require('@/assets/images/slide-type-preview/fr/q&a.svg')
const previewPickAnswerFr = require('@/assets/images/slide-type-preview/fr/pick-answer.svg')
const previewPickImageFr = require('@/assets/images/slide-type-preview/fr/pick-image.svg')
const previewTypeAnswerFr = require('@/assets/images/slide-type-preview/fr/type-answer.svg')
const previewHeadingFr = require('@/assets/images/slide-type-preview/fr/heading.svg')
const previewBulletPointsFr = require('@/assets/images/slide-type-preview/fr/list.svg')
const previewQrcodeFr = require('@/assets/images/slide-type-preview/fr/qr-code.svg')
const previewImageFr = require('@/assets/images/slide-type-preview/fr/image.svg')
const previewYoutubeFr = require('@/assets/images/slide-type-preview/fr/youtube.svg')
// const previewDocumentFr = require('@/assets/images/slide-type-preview/fr/document.svg')
const previewGoogleSlideFr = require('@/assets/images/slide-type-preview/fr/google-slides.svg')
const previewSpinnerWheelFr = require('@/assets/images/slide-type-preview/fr/spinner-wheel.svg')
const previewBrainstormFr = require('@/assets/images/slide-type-preview/fr/brainstorm.svg')
const previewMatchPairsFr = require('@/assets/images/slide-type-preview/fr/match-pairs.svg')
const previewCorrectOrderFr = require('@/assets/images/slide-type-preview/fr/correct-order.svg')
const previewPollFr = require('@/assets/images/slide-type-preview/fr/poll.svg')
const previewContentFr = require('@/assets/images/slide-type-preview/fr/content.svg')

export const slideType = {
  multipleChoice: 'multipleChoice',
  imageChoice: 'imageChoice',
  openEnded: 'openEnded',
  scale: 'scale',
  question: 'question',
  pickAnswer: 'pickAnswer',
  pickImage: 'pickImage',
  typeAnswer: 'typeAnswer',
  wordCloud: 'wordCloud',
  spinnerWheel: 'spinnerWheel',
  freeStyle: 'freestyle',
  matchPairs: 'matchPairs',
  correctOrder: 'correctOrder',
  leaderboard: 'leaderboard',
  ideas: 'ideas',
  textSlide: 'textSlide',
  bulletPoints: 'bulletPoints',
  qrcode: 'qrcode',
  image: 'image',
  youtube: 'youtube',
  document: 'document',
  googleSlides: 'googleSlides',
  categorise: 'categorise',
}

const allSlideTypes = [
  {
    title: 'Popular',
    key: 'popular',
    desc: 'Popular',
    slideTypes: [
      {

        name: 'Poll',
        icon: 'fas fa-signal',
        type: slideType.imageChoice,
        desc: 'Pose a question, provide the options and let participants choose one or more. You can also add images',
        ahaIcon: 'multiple-choice',
        ahaIconWhite: 'multiple-choice-w',
        preview: 'poll',
        previewUrl: previewPoll,
        previewUrlFr: previewPollFr,
        videoTutorialUrl: 'https://youtu.be/d1NwuHPi_Yo',
      },
      {
        name: 'Pick Answer',
        icon: 'fas fa-tasks',
        type: slideType.pickAnswer,
        slideType: null,
        desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
        label: 'Quiz',
        ahaIcon: 'pick-answer',
        ahaIconWhite: 'pick-answer-w',
        preview: 'pickAnswer',
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        videoTutorialUrl: 'https://youtu.be/RGX2dmuvTEA',
      },
      {
        name: 'Word Cloud',
        type: slideType.wordCloud,
        icon: 'fas fa-cloud',
        desc: 'Pose a question and let participants write 1 or 2-word answers. The more popular an answer is, the larger it will appear on screen.',
        ahaIcon: 'word-cloud',
        ahaIconWhite: 'word-cloud-w',
        preview: 'wordCloud',
        previewUrl: previewWordCloud,
        previewUrlFr: previewWordCloudFr,
        videoTutorialUrl: 'https://www.youtube.com/embed/fAIi4n1V8yk',
      },
      {
        name: 'Spinner Wheel',
        icon: 'fas fa-keyboard',
        type: slideType.spinnerWheel,
        desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
        label: '',
        ahaIcon: 'spinner-wheel',
        ahaIconWhite: 'spinner-wheel-w',
        preview: 'spinnerWheel',
        previewUrl: previewSpinnerWheel,
        previewUrlFr: previewSpinnerWheelFr,
        videoTutorialUrl: 'https://www.youtube.com/embed/-PaqZrxnDOw',
      },
      {
        name: 'Content',
        type: slideType.freeStyle,
        desc: 'Add and edit text, images and bullet points.',
        ahaIcon: 'content',
        ahaIconWhite: 'content-w',
        preview: 'content',
        previewUrl: previewContent,
        previewUrlFr: previewContentFr,
      },
    ],
  },
  {
    title: 'Quiz',
    key: 'quiz',
    desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
    slideTypes: [
      {
        name: 'Pick Answer',
        icon: 'fas fa-tasks',
        type: slideType.pickAnswer,
        slideType: null,
        desc: 'Ask a quiz question and write the options. Participants try to choose the correct answer to score points.',
        label: 'Quiz',
        ahaIcon: 'pick-answer',
        ahaIconWhite: 'pick-answer-w',
        preview: 'pickAnswer',
        previewUrl: previewPickAnswer,
        previewUrlFr: previewPickAnswerFr,
        videoTutorialUrl: 'https://youtu.be/RGX2dmuvTEA',
      },
      {
        name: 'Pick Image',
        icon: 'fas fa-images',
        type: slideType.pickAnswer,
        slideType: 'imageChoice',
        desc: 'Ask a quiz question and provide image options. Participants try to choose the correct image to score points.',
        label: 'Quiz',
        ahaIcon: 'pick-image',
        ahaIconWhite: 'pick-image-w',
        preview: 'pickImage',
        previewUrl: previewPickImage,
        previewUrlFr: previewPickImageFr,
      },
      {
        name: 'Type Answer',
        icon: 'fas fa-keyboard',
        type: slideType.pickAnswer,
        slideType: 'typeAnswer',
        desc: 'Ask a quiz question and write in the answer(s) that you will accept. Participants try to write the correct answer and will score points if it matches your accepted answer(s).',
        label: 'Quiz',
        ahaIcon: 'type-answer',
        ahaIconWhite: 'type-answer-w',
        preview: 'typeAnswer',
        previewUrl: previewTypeAnswer,
        previewUrlFr: previewTypeAnswerFr,
        videoTutorialUrl: 'https://youtu.be/LOTd2BLgPgw',
      },
      {
        name: 'Spinner Wheel',
        icon: 'fas fa-keyboard',
        type: slideType.spinnerWheel,
        desc: 'Ask quiz questions, or play games, and let your participants compete for victory!',
        label: '',
        ahaIcon: 'spinner-wheel',
        ahaIconWhite: 'spinner-wheel-w',
        preview: 'spinnerWheel',
        previewUrl: previewSpinnerWheel,
        previewUrlFr: previewSpinnerWheelFr,
        videoTutorialUrl: 'https://www.youtube.com/embed/-PaqZrxnDOw',
      },
      {
        name: 'Match Pairs',
        type: slideType.pickAnswer,
        slideType: slideType.matchPairs,
        desc: 'Pose a question and provide prompts and answers. Participants try to match each prompt to its accompanying answer.',
        label: 'Quiz',
        ahaIcon: 'match-pairs',
        ahaIconWhite: 'match-pairs-w',
        preview: 'matchPairs',
        previewUrl: previewMatchPairs,
        previewUrlFr: previewMatchPairsFr,
        videoTutorialUrl: 'https://youtu.be/0qvPBJcxvYo',
      },
      {
        name: 'Correct Order',
        type: slideType.pickAnswer,
        slideType: slideType.correctOrder,
        desc: 'Provide up to 10 mixed-up options and let participants order them.',
        label: 'Quiz',
        ahaIcon: 'correct-order',
        ahaIconWhite: 'correct-order-w',
        preview: 'correctorder',
        previewUrl: previewCorrectOrder,
        previewUrlFr: previewCorrectOrderFr,
        videoTutorialUrl: 'https://youtu.be/wNCbN-Q7UY8',
      },
      {
        name: 'Leaderboard',
        type: slideType.leaderboard,
        noType: true,
      },
    ],
  },
  {
    title: 'Poll',
    key: 'poll',
    desc: 'Collect opinions from your audience in a range of formats, or address their questions through a Q&A slide!',
    slideTypes: [
      {
        name: 'Poll',
        icon: 'fas fa-signal',
        type: slideType.multipleChoice,
        desc: 'Pose a question, provide the options and let participants choose one or more. You can also add images',
        ahaIcon: 'multiple-choice',
        ahaIconWhite: 'multiple-choice-w',
        preview: 'poll',
        previewUrl: previewPoll,
        previewUrlFr: previewPollFr,
        hidden: true,
      },
      {
        name: 'Poll',
        icon: 'fas fa-signal',
        type: slideType.imageChoice,
        desc: 'Pose a question, provide the options and let participants choose one or more. You can also add images',
        ahaIcon: 'multiple-choice',
        ahaIconWhite: 'multiple-choice-w',
        preview: 'poll',
        previewUrl: previewPoll,
        previewUrlFr: previewPollFr,
      },
      {
        name: 'Open Ended',
        icon: 'fas fa-comment-dots',
        type: slideType.openEnded,
        desc: 'Pose a question and let participants freely write their responses. Set fields for participants´ names, teams, emails or avatars.',
        ahaIcon: 'open-ended',
        ahaIconWhite: 'open-ended-w',
        preview: 'openEnded',
        previewUrl: previewOpenEnded,
        previewUrlFr: previewOpenEndedFr,
        videoTutorialUrl: 'https://www.youtube.com/embed/O7o7j4BZDDc',
      },
      {
        name: 'Word Cloud',
        type: slideType.wordCloud,
        icon: 'fas fa-cloud',
        desc: 'Pose a question and let participants write 1 or 2-word answers. The more popular an answer is, the larger it will appear on screen.',
        ahaIcon: 'word-cloud',
        ahaIconWhite: 'word-cloud-w',
        preview: 'wordCloud',
        previewUrl: previewWordCloud,
        previewUrlFr: previewWordCloudFr,
        videoTutorialUrl: 'https://www.youtube.com/embed/fAIi4n1V8yk',
      },
      {
        name: 'Rating Scale',
        type: slideType.scale,
        icon: 'fas fa-sliders-h',
        desc: 'Pose a question, write statements and let your participants rate each statement on a scale. Results are shown in a colour-coded graph that shows the popularity of each statement.',
        ahaIcon: 'scales',
        ahaIconWhite: 'scales-w',
        preview: 'scale',
        previewUrl: previewScale,
        previewUrlFr: previewScaleFr,
        videoTutorialUrl: 'https://www.youtube.com/embed/1Iamxm2iJeM',
      },
      {
        name: 'Q&A',
        type: slideType.question,
        icon: 'fas fa-comment',
        iconInside: true,
        desc: 'Participants write and vote on questions for you to answer. All questions are displayed on screen for you to address one by one. Pin questions to save them or mark as answered to remove them.',
        ahaIcon: 'qa',
        ahaIconWhite: 'q&a-w',
        preview: 'question',
        previewUrl: previewQuestion,
        previewUrlFr: previewQuestionFr,
        videoTutorialUrl: 'https://www.youtube.com/embed/Z1kCoy9i6N0',
      },
      {
        name: 'Brainstorm',
        type: slideType.ideas,
        icon: 'fas fa-comment',
        iconInside: true,
        desc: 'Provide a topic and let the audience submit their ideas. Each participant votes for their favourite ideas and the results are ranked by popularity.',
        ahaIcon: 'brainstorm',
        ahaIconWhite: 'brainstorm-white',
        preview: 'brainstorm',
        previewUrl: previewBrainstorm,
        previewUrlFr: previewBrainstormFr,
        videoTutorialUrl: 'https://www.youtube.com/embed/JaxWbKImUcQ',
      },
    ],
  },
  {
    title: 'Content',
    key: 'content',
    desc: 'Add text content, image, video... to your presentation',
    slideTypes: [
      {
        name: 'Content',
        type: slideType.freeStyle,
        desc: 'Add and edit text, images and bullet points.',
        ahaIcon: 'content',
        ahaIconWhite: 'content-w',
        preview: 'content',
        previewUrl: previewContent,
        previewUrlFr: previewContentFr,
      },
      {
        name: 'Heading',
        subheading: 'Subheading',
        type: slideType.textSlide,
        desc: 'Write a heading and an optional subheading. You can use this for introducing a question or quiz slide. This slide type also works great as an opening to a new section of the presentation.',
        ahaIcon: 'heading',
        ahaIconWhite: 'heading-w',
        preview: 'heading',
        previewUrl: previewHeading,
        previewUrlFr: previewHeadingFr,
      },
      {
        name: 'List',
        type: slideType.bulletPoints,
        html: '<i class="fas fa-list bulletPoints-icon"></i>',
        desc: 'Write a bullet point list. You can also add a heading and a subheading.',
        ahaIcon: 'list',
        ahaIconWhite: 'list-w',
        preview: 'bulletPoints',
        previewUrl: previewBulletPoints,
        previewUrlFr: previewBulletPointsFr,
      },
      {
        name: 'QR Code',
        type: slideType.qrcode,
        icon: 'fas fa-qrcode',
        desc: 'Display the unique QR code for your presentation. Participants can scan this on their devices to join your quiz. Tip: You can also show this QR code on any other slide types by clicking the top of your slide.',
        ahaIcon: 'qr-code',
        ahaIconWhite: 'qr-code-w',
        preview: 'qrcode',
        previewUrl: previewQrcode,
        previewUrlFr: previewQrcodeFr,
      },
      {
        name: 'Image',
        type: slideType.image,
        icon: 'far fa-image',
        desc: 'Display an image either centrally on the slide or full-screen. Use your own images or choose ones from our library.',
        ahaIcon: 'type-image',
        ahaIconWhite: 'image-w',
        preview: 'image',
        previewUrl: previewImage,
        previewUrlFr: previewImageFr,
      },
      {
        name: 'YouTube',
        type: slideType.youtube,
        icon: 'fab fa-youtube',
        desc: 'Embed a YouTube video. Simply copy and paste the YouTube URL into the slide.',
        ahaIcon: 'youtube',
        ahaIconWhite: 'youtube-w',
        preview: 'youtube',
        previewUrl: previewYoutube,
        previewUrlFr: previewYoutubeFr,
      },
      {
        name: 'Document',
        type: slideType.document,
        icon: 'fas fa-file-import',
        desc: 'Import a PowerPoint or PDF document into this presentation.',
        ahaIcon: 'document',
        ahaIconWhite: 'document-w',
        preview: 'document',
        previewUrl: previewDocument,
        previewUrlFr: previewDocument,
        hidden: true,
      },
      {
        name: 'Google Slides',
        type: slideType.googleSlides,
        icon: 'fab fa-google',
        desc: 'Embed a Google Slides presentation. The entire slideshow will be displayed within this one slide.',
        ahaIcon: 'google-slides-brand-b',
        ahaIconWhite: 'google-slides-brand-w',
        preview: 'googleSlides',
        previewUrl: previewGoogleSlide,
        previewUrlFr: previewGoogleSlideFr,
      },
    ],
  },
]

export default allSlideTypes
